import React from "react";
import {
  Button,
  Divider,
  TableAdv,
  PageHeader,
  PageTitle,
} from "../../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../../utils";

const Costs = () => {
  const tableData = [];
  const columns = [
    {
      key: "costType",
      label: "Cost Type",
    },
    {
      key: "date",
      label: "Date",
      render: (row) => dateFormator(row.date, "month-day-year"),
    },
    {
      key: "amount",
      label: "Amount",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-1">
          <Button
            type="icon"
            icon="edit_square"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="delete"
            color="black"
            variant="text"
            size="xs"
          />
        </div>
      ),
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);

  return (
    <div>
      <div className="my-3">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"COSTS"} tag="p" />
            </div>
          }
          RightSection={
            <>
              <Button
                title="Add"
                size="sm"
                icon={"add"}
                iconPosition={"before"}
              />
            </>
          }
        />
        <Divider />
      </div>
      <div className="my-6">
        <TableAdv tableId={`immigration_h1b_h1bview_costs`} rows={mappedRows} columns={columns} hideToolBar />
      </div>
    </div>
  );
};

export default Costs;
